
import { Component, Vue } from "vue-property-decorator";
import MoqupOrganigram from "@/views/moqups/lot/Organigram.vue";

@Component({
  components: {
    MoqupOrganigram,
  },
})export default class Lot extends Vue {}
